// Mock data pour le blog Bozzam

// Articles mockés avec catégories et tags
export const mockArticles = [
  {
    id: '1',
    title: 'Guide complet pour créer son entreprise en 2026',
    slug: 'guide-complet-creer-entreprise-2026',
    excerpt: 'Tout ce qu\'il faut savoir pour créer son entreprise en 2026 : statuts, démarches, aides, et pièges à éviter.',
    content: 'Contenu complet de l\'article...',
    category: 'Guides complets',
    tags: ['Création', 'Entrepreneuriat', '2026'],
    readTime: 12,
    publishedAt: '2026-01-15',
    featured: true
  },
  {
    id: '2',
    title: 'Les 10 erreurs fatales des freelances débutants',
    slug: 'erreurs-freelances-debutants',
    excerpt: 'Évitez ces erreurs courantes qui peuvent coûter cher aux freelances qui se lancent.',
    content: 'Contenu complet de l\'article...',
    category: 'Erreurs à éviter',
    tags: ['Freelance', 'Erreurs', 'Débutant'],
    readTime: 10,
    publishedAt: '2026-01-10',
    featured: true
  },
  {
    id: '3',
    title: 'SASU : avantages et inconvénients',
    slug: 'sasu-avantages-inconvenients',
    excerpt: 'Analyse complète du statut SASU : fiscalité, cotisations, avantages et inconvénients.',
    content: 'Contenu complet de l\'article...',
    category: 'Fiscalité',
    tags: ['SASU', 'Statut', 'Fiscalité'],
    readTime: 7,
    publishedAt: '2026-01-08',
    featured: false
  },
  {
    id: '4',
    title: 'Chômage et création d\'entreprise : comment ça marche ?',
    slug: 'chomage-creation-entreprise',
    excerpt: 'Tout comprendre sur les droits au chômage lors de la création d\'entreprise.',
    content: 'Contenu complet de l\'article...',
    category: 'Chômage & aides',
    tags: ['Chômage', 'ARE', 'Création'],
    readTime: 9,
    publishedAt: '2026-01-05',
    featured: false
  },
  {
    id: '5',
    title: 'Quel TJM fixer quand on débute ?',
    slug: 'tjm-fixer-debuter-freelance',
    excerpt: 'Conseils pratiques pour fixer son taux journalier moyen en tant que freelance débutant.',
    content: 'Contenu complet de l\'article...',
    category: 'Freelance pratique',
    tags: ['TJM', 'Freelance', 'Tarifs'],
    readTime: 5,
    publishedAt: '2026-01-03',
    featured: false
  },
  {
    id: '6',
    title: 'Optimiser ses charges légalement',
    slug: 'optimiser-charges-legalement',
    excerpt: 'Techniques légales pour optimiser ses charges et réduire ses impôts en tant qu\'entrepreneur.',
    content: 'Contenu complet de l\'article...',
    category: 'Bons plans',
    tags: ['Optimisation', 'Charges', 'Légal'],
    readTime: 6,
    publishedAt: '2026-01-01',
    featured: false
  },
  {
    id: '7',
    title: 'Portage salarial vs Freelance : le comparatif complet 2026',
    slug: 'portage-salarial-vs-freelance',
    excerpt: 'Freelance en direct ou portage salarial ? On compare tout : revenus nets, protection sociale, gestion.',
    category: 'Statuts',
    tags: ['Portage salarial', 'Freelance', 'Comparatif'],
    readTime: 12,
    publishedAt: '2026-02-10',
    featured: true
  },
  {
    id: '8',
    title: 'Retraite du freelance : comment valider vos trimestres en 2026',
    slug: 'retraite-freelance-trimestres',
    excerpt: 'Combien de trimestres validez-vous ? Comment préparer votre retraite ? Le guide complet.',
    category: 'Protection sociale',
    tags: ['Retraite', 'Trimestres', 'Prévoyance'],
    readTime: 10,
    publishedAt: '2026-02-08',
    featured: false
  },
  {
    id: '9',
    title: 'Facture auto-entrepreneur : modèle et mentions obligatoires 2026',
    slug: 'facture-auto-entrepreneur-2026',
    excerpt: 'Les 14 mentions obligatoires, le modèle prêt à copier, et les erreurs qui coûtent cher.',
    category: 'Gestion',
    tags: ['Facture', 'Mentions obligatoires', 'Modèle'],
    readTime: 8,
    publishedAt: '2026-02-05',
    featured: true
  },
  {
    id: '10',
    title: 'Quelle banque pro choisir en 2026 ? Comparatif Qonto, Shine, Blank',
    slug: 'banque-pro-comparatif-2026',
    excerpt: 'On compare Qonto, Shine et Blank : tarifs, fonctionnalités et verdict.',
    category: 'Gestion',
    tags: ['Banque pro', 'Qonto', 'Shine', 'Comparatif'],
    readTime: 9,
    publishedAt: '2026-02-03',
    featured: true
  },
  {
    id: '11',
    title: 'La CFE : cette taxe surprise que tous les entrepreneurs oublient',
    slug: 'cfe-taxe-meconnue',
    excerpt: 'Vous avez reçu un avis de CFE et vous ne comprenez rien ? On vous explique tout.',
    category: 'Fiscalité',
    tags: ['CFE', 'Taxe', 'Exonération'],
    readTime: 7,
    publishedAt: '2026-01-28',
    featured: false
  },
  {
    id: '12',
    title: 'Protection sociale du freelance : le guide complet 2026',
    slug: 'protection-sociale-freelance',
    excerpt: 'Maladie, maternité, retraite, prévoyance : quelle couverture quand on est indépendant ?',
    category: 'Protection sociale',
    tags: ['Protection sociale', 'Maladie', 'Prévoyance'],
    readTime: 11,
    publishedAt: '2026-01-25',
    featured: true
  },
  {
    id: '13',
    title: 'Micro-entreprise 2026 : tous les changements à connaître',
    slug: 'micro-entreprise-changements-2026',
    excerpt: 'Hausse des cotisations, nouveaux seuils TVA, ACRE modifiée : tout ce qui change.',
    category: 'Actualités',
    tags: ['Micro-entreprise', '2026', 'Changements'],
    readTime: 8,
    publishedAt: '2026-01-20',
    featured: true
  },
  {
    id: '14',
    title: 'TVA et auto-entrepreneur : le guide de survie 2026',
    slug: 'tva-auto-entrepreneur-guide',
    excerpt: 'Franchise TVA, dépassement de seuil, première déclaration : tout comprendre.',
    category: 'Fiscalité',
    tags: ['TVA', 'Auto-entrepreneur', 'Seuils'],
    readTime: 10,
    publishedAt: '2026-01-15',
    featured: false
  },
  {
    id: '15',
    title: 'Devenir freelance en 2026 : le guide pas à pas',
    slug: 'devenir-freelance-guide-2026',
    excerpt: 'De la décision au premier client : les 10 étapes concrètes pour se lancer.',
    category: 'Guides complets',
    tags: ['Freelance', 'Guide', 'Création'],
    readTime: 14,
    publishedAt: '2026-01-10',
    featured: true
  },
  {
    id: '16',
    title: 'Cumul emploi salarié + micro-entreprise : le mode d\'emploi',
    slug: 'cumul-salarie-micro-entreprise',
    excerpt: 'Salarié et auto-entrepreneur en même temps ? Le guide complet du cumul en 2026.',
    category: 'Statuts',
    tags: ['Cumul', 'Salarié', 'Micro-entreprise'],
    readTime: 9,
    publishedAt: '2026-01-05',
    featured: true
  },
  {
    id: '17',
    title: 'Créer une holding en freelance : pourquoi et comment en 2026',
    slug: 'holding-freelance-guide-2026',
    excerpt: 'Holding, société mère, filiale : comment structurer votre activité freelance pour optimiser votre fiscalité et investir intelligemment.',
    category: 'Optimisation',
    tags: ['Holding', 'Fiscalité', 'Optimisation'],
    readTime: 14,
    publishedAt: '2026-03-15',
    featured: true
  },
  {
    id: '18',
    title: 'SASU vs EURL : quel statut quand on est marié avec enfants ?',
    slug: 'sasu-vs-eurl-famille-marie',
    excerpt: 'Marié, pacsé, avec enfants ? Le choix SASU ou EURL a un impact énorme sur votre famille. Comparatif complet 2026.',
    category: 'Statuts',
    tags: ['SASU', 'EURL', 'Famille', 'Mariage'],
    readTime: 12,
    publishedAt: '2026-03-12',
    featured: true
  },
  {
    id: '19',
    title: 'Investir en bourse et crypto via sa société en 2026',
    slug: 'investir-bourse-crypto-societe',
    excerpt: 'Compte-titres société, PEA, crypto-actifs : comment investir intelligemment via votre SASU, EURL ou holding en 2026.',
    category: 'Optimisation',
    tags: ['Bourse', 'Crypto', 'Investissement'],
    readTime: 13,
    publishedAt: '2026-03-10',
    featured: true
  },
  {
    id: '20',
    title: 'SCI et holding freelance : investir dans l\'immobilier intelligemment',
    slug: 'sci-holding-immobilier-freelance',
    excerpt: 'Créer une SCI via votre holding pour investir dans l\'immobilier locatif : montage, fiscalité et stratégies 2026.',
    category: 'Optimisation',
    tags: ['SCI', 'Immobilier', 'Holding'],
    readTime: 12,
    publishedAt: '2026-03-08',
    featured: true
  },
  {
    id: '21',
    title: 'Optimisation fiscale avancée pour freelances : les stratégies 2026',
    slug: 'optimisation-fiscale-avancee-2026',
    excerpt: 'PER, Madelin, holding, management fees, épargne salariale : toutes les stratégies légales pour réduire votre impôt en 2026.',
    category: 'Optimisation',
    tags: ['Optimisation', 'Fiscalité', 'PER'],
    readTime: 15,
    publishedAt: '2026-03-05',
    featured: true
  },
  {
    id: '22',
    title: 'CDI vs Portage salarial : le comparatif complet 2026',
    slug: 'cdi-vs-portage-salarial',
    excerpt: 'Salaire, protection sociale, liberté, retraite : faut-il quitter son CDI pour le portage salarial ? Analyse chiffrée.',
    category: 'Statuts',
    tags: ['CDI', 'Portage salarial', 'Comparatif'],
    readTime: 11,
    publishedAt: '2026-03-20',
    featured: true
  },
  {
    id: '23',
    title: 'Seuils micro-entreprise : que se passe-t-il quand on dépasse ?',
    slug: 'seuils-depassement-micro-entreprise',
    excerpt: 'Seuil de tolérance, franchise TVA, passage en société : tout ce qui change quand votre CA explose en micro.',
    category: 'Fiscalité',
    tags: ['Micro-entreprise', 'Seuils', 'TVA'],
    readTime: 10,
    publishedAt: '2026-03-19',
    featured: true
  },
  {
    id: '24',
    title: 'Micro-entreprise : le guide complet du statut en 2026',
    slug: 'micro-entreprise-guide-complet-2026',
    excerpt: 'Création, charges, plafonds, CFE, TVA, déclarations : tout savoir sur la micro-entreprise en 2026.',
    category: 'Guides',
    tags: ['Micro-entreprise', 'Création', 'Guide'],
    readTime: 14,
    publishedAt: '2026-03-18',
    featured: true
  },
  {
    id: '25',
    title: 'SASU à l\'IS vs IR : quel régime fiscal choisir ?',
    slug: 'sasu-is-vs-ir-regime-fiscal',
    excerpt: 'IS ou IR en SASU ? Le choix a un impact majeur sur vos impôts, dividendes et charges. Simulation détaillée 2026.',
    category: 'Fiscalité',
    tags: ['SASU', 'IS', 'IR', 'Fiscalité'],
    readTime: 12,
    publishedAt: '2026-03-17',
    featured: true
  },
  {
    id: '26',
    title: 'EURL : IS ou IR ? Le comparatif fiscal 2026',
    slug: 'eurl-is-ou-ir-comparatif',
    excerpt: 'Gérant majoritaire EURL : faut-il opter pour l\'IS ou rester à l\'IR ? Simulation et cas pratiques 2026.',
    category: 'Fiscalité',
    tags: ['EURL', 'IS', 'IR', 'TNS'],
    readTime: 11,
    publishedAt: '2026-03-16',
    featured: true
  },
  {
    id: '27',
    title: 'Barème progressif vs flat tax : quand opter pour le barème ?',
    slug: 'bareme-progressif-vs-flat-tax',
    excerpt: 'Flat tax 30% ou barème progressif avec abattement 40% ? La réponse dépend de votre situation. Calculs 2026.',
    category: 'Fiscalité',
    tags: ['Flat tax', 'Barème', 'Dividendes', 'IR'],
    readTime: 10,
    publishedAt: '2026-03-15',
    featured: true
  },
  {
    id: '28',
    title: 'Freelance vs CDI : pourquoi franchir le pas en 2026 ?',
    slug: 'freelance-vs-cdi-pourquoi',
    excerpt: 'Revenus, liberté, sécurité, retraite : le comparatif honnête entre salariat et freelance. Chiffres 2026.',
    category: 'Freelance pratique',
    tags: ['Freelance', 'CDI', 'Comparatif'],
    readTime: 12,
    publishedAt: '2026-03-14',
    featured: true
  },
  {
    id: '29',
    title: 'Aides à la création d\'entreprise : le guide complet 2026',
    slug: 'aides-creation-entreprise-2026',
    excerpt: 'ACRE, ARE, ARCE, NACRE, prêt d\'honneur, garantie BPI : toutes les aides pour créer votre entreprise en 2026.',
    category: 'Guides',
    tags: ['Aides', 'Création', 'ACRE', 'ARE'],
    readTime: 13,
    publishedAt: '2026-03-13',
    featured: true
  },
  {
    id: '30',
    title: 'Gérer sa trésorerie quand on est freelance',
    slug: 'gerer-tresorerie-freelance',
    excerpt: 'Provisions, acomptes IS, URSSAF trimestriel, TVA : comment ne jamais être pris au dépourvu.',
    category: 'Gestion',
    tags: ['Trésorerie', 'Gestion', 'Freelance'],
    readTime: 10,
    publishedAt: '2026-03-12',
    featured: true
  },
  {
    id: '31',
    title: 'Assurance RC Pro freelance : obligatoire ou pas ?',
    slug: 'assurance-rc-pro-freelance',
    excerpt: 'Responsabilité civile professionnelle : qui est obligé, combien ça coûte, que couvre-t-elle ? Guide 2026.',
    category: 'Protection sociale',
    tags: ['Assurance', 'RC Pro', 'Freelance'],
    readTime: 8,
    publishedAt: '2026-03-11',
    featured: true
  },
  {
    id: '32',
    title: 'Le PER pour freelance : l\'arme anti-impôts en 2026',
    slug: 'per-freelance-optimisation-fiscale',
    excerpt: 'Plan d\'Épargne Retraite : plafonds de déduction TNS vs salarié, stratégies, simulation d\'économie d\'impôt.',
    category: 'Optimisation',
    tags: ['PER', 'Retraite', 'Optimisation', 'Fiscalité'],
    readTime: 11,
    publishedAt: '2026-03-10',
    featured: true
  },
  {
    id: '33',
    title: 'TVA intracommunautaire pour freelances : guide pratique',
    slug: 'tva-intracommunautaire-freelance',
    excerpt: 'Clients en Europe, numéro de TVA intracommunautaire, autoliquidation : le guide pour facturer à l\'étranger.',
    category: 'Fiscalité',
    tags: ['TVA', 'Intracommunautaire', 'Europe'],
    readTime: 9,
    publishedAt: '2026-03-09',
    featured: true
  },
  {
    id: '34',
    title: 'Freelance et prêt immobilier : comment convaincre la banque',
    slug: 'freelance-pret-immobilier-banque',
    excerpt: 'Bilan, ancienneté, apport, courtier : les clés pour obtenir un prêt immobilier quand on est indépendant.',
    category: 'Freelance pratique',
    tags: ['Prêt immobilier', 'Banque', 'Freelance'],
    readTime: 10,
    publishedAt: '2026-03-08',
    featured: true
  },
  {
    id: '35',
    title: 'Frais déductibles en société : le guide SASU et EURL',
    slug: 'frais-deductibles-societe-sasu-eurl',
    excerpt: 'Repas, transport, bureau, téléphone, formation : tout ce que vous pouvez déduire légalement en 2026.',
    category: 'Fiscalité',
    tags: ['Frais', 'Déductibles', 'SASU', 'EURL'],
    readTime: 12,
    publishedAt: '2026-03-07',
    featured: true
  },
  {
    id: '36',
    title: 'Cotisations retraite freelance : tout comprendre en 2026',
    slug: 'cotisations-retraite-freelance-2026',
    excerpt: 'Trimestres, points, CIPAV, SSI, AGIRC-ARRCO : combien cotisez-vous vraiment et quelle retraite espérer ?',
    category: 'Protection sociale',
    tags: ['Retraite', 'Cotisations', 'Freelance'],
    readTime: 11,
    publishedAt: '2026-03-06',
    featured: true
  },
  {
    id: '37',
    title: 'Frais kilométriques et notes de frais : le guide freelance et portage 2026',
    slug: 'frais-km-notes-frais-freelance-portage',
    excerpt: 'IK, repas, hôtel, matériel : tout ce que vous pouvez vous faire rembourser pour augmenter votre net en freelance et en portage salarial.',
    category: 'Optimisation',
    tags: ['Frais kilométriques', 'Notes de frais', 'Portage', 'Freelance'],
    readTime: 13,
    publishedAt: '2026-03-21',
    featured: true
  },
  {
    id: '38',
    title: 'Épargne salariale en SASU : PEE et PERE-CO même seul',
    slug: 'epargne-salariale-sasu-pee-pereco',
    excerpt: 'Jusqu\'à 11 000€/an exonérés d\'IR et de charges : l\'épargne salariale est accessible même au président SASU seul.',
    category: 'Optimisation',
    tags: ['Épargne salariale', 'PEE', 'PERE-CO', 'SASU'],
    readTime: 12,
    publishedAt: '2026-03-24',
    featured: true
  },
  {
    id: '39',
    title: 'Apport-cession (150-0 B ter) : reporter l\'impôt sur la plus-value',
    slug: 'apport-cession-150-0-b-ter-report',
    excerpt: 'Vous vendez votre société ? Le mécanisme d\'apport-cession permet de réinvestir sans payer immédiatement la plus-value.',
    category: 'Optimisation',
    tags: ['Plus-value', 'Apport-cession', 'Holding', 'Cession'],
    readTime: 13,
    publishedAt: '2026-03-23',
    featured: true
  },
  {
    id: '40',
    title: 'Rémunération optimale du dirigeant : le calcul exact en 2026',
    slug: 'remuneration-optimale-dirigeant-2026',
    excerpt: 'Salaire, dividendes, PER, épargne salariale : la méthode pas à pas pour maximiser votre net disponible.',
    category: 'Optimisation',
    tags: ['Rémunération', 'Dividendes', 'Optimisation', 'SASU', 'EURL'],
    readTime: 14,
    publishedAt: '2026-03-22',
    featured: true
  },
  {
    id: '41',
    title: 'Compte courant d\'associé : rémunérer sa trésorerie personnelle en 2026',
    slug: 'compte-courant-associe-remuneration-tresorerie',
    excerpt: 'Prêter de l\'argent à sa société et toucher des intérêts déductibles : le levier discret pour sortir de la trésorerie sans flat tax.',
    category: 'Optimisation',
    tags: ['Compte courant', 'Trésorerie', 'SASU', 'EURL', 'Optimisation'],
    readTime: 12,
    publishedAt: '2026-03-26',
    featured: true
  },
  {
    id: '42',
    title: 'Voiture de société vs IK vs LOA : le comparatif fiscal 2026',
    slug: 'voiture-societe-vs-ik-vs-loa-2026',
    excerpt: 'Achat, location longue durée, leasing ou indemnités kilométriques : le match chiffré pour choisir la bonne stratégie véhicule en SASU/EURL.',
    category: 'Optimisation',
    tags: ['Voiture', 'LOA', 'IK', 'SASU', 'EURL', 'Déduction'],
    readTime: 13,
    publishedAt: '2026-03-27',
    featured: true
  },
  {
    id: '43',
    title: 'Pacte Dutreil : transmettre sa société avec 75% d\'abattement',
    slug: 'pacte-dutreil-transmission-societe-2026',
    excerpt: 'Donation ou succession de votre société avec 75% d\'abattement sur les droits : les 5 conditions et la marche à suivre en 2026.',
    category: 'Optimisation',
    tags: ['Transmission', 'Dutreil', 'Donation', 'Holding', 'Succession'],
    readTime: 14,
    publishedAt: '2026-03-28',
    featured: true
  },
  {
    id: '44',
    title: 'Holding pour freelance : le guide stratégique complet 2026',
    slug: 'holding-freelance-strategie-complete-2026',
    excerpt: 'Pourquoi et comment monter une holding quand on est freelance : régime mère-fille, apport de titres, filiales, SCI, crédit bancaire. Le playbook complet avec bilans chiffrés.',
    category: 'Optimisation',
    tags: ['Holding', 'Mère-fille', 'SCI', 'SASU', 'EURL', 'Stratégie'],
    readTime: 18,
    publishedAt: '2026-04-02',
    featured: true
  },
  {
    id: '45',
    title: 'Salaire SMIC + dividendes vs salaire plein : la bonne stratégie 2026',
    slug: 'salaire-smic-dividendes-vs-salaire-plein-2026',
    excerpt: 'Faut-il se verser le SMIC + dividendes ou un salaire plein en SASU/EURL ? Le comparatif chiffré selon votre statut en 2026.',
    category: 'Optimisation',
    tags: ['Salaire', 'Dividendes', 'SMIC', 'SASU', 'EURL', 'Stratégie'],
    readTime: 13,
    publishedAt: '2026-04-01',
    featured: false
  },
  {
    id: '46',
    title: 'Passer de SASU à EURL : quand et pourquoi en 2026',
    slug: 'passer-sasu-a-eurl-quand-pourquoi-2026',
    excerpt: 'À partir de quel niveau de bénéfice l\'EURL devient plus rentable que la SASU ? Procédure de transformation, gains annuels, cas où il ne faut pas le faire.',
    category: 'Optimisation',
    tags: ['SASU', 'EURL', 'Transformation', 'Fiscalité', 'Stratégie'],
    readTime: 12,
    publishedAt: '2026-03-31',
    featured: false
  },
  {
    id: '47',
    title: 'Compte-titres via holding : investir en bourse avec sa société en 2026',
    slug: 'compte-titres-holding-bourse-actions-2026',
    excerpt: 'Ouvrir un compte-titres au nom de sa holding pour investir en bourse : fiscalité IS, régime mère-fille sur dividendes, brokers compatibles, exemples chiffrés.',
    category: 'Optimisation',
    tags: ['Compte-titres', 'Bourse', 'Holding', 'Actions', 'Dividendes'],
    readTime: 14,
    publishedAt: '2026-03-30',
    featured: false
  },
  {
    id: '48',
    title: 'Facturation électronique obligatoire 2026 : PDP, Chorus Pro et calendrier',
    slug: 'facturation-electronique-obligatoire-2026',
    excerpt: 'Toutes les entreprises passent à la facture électronique en 2026 : plateformes agréées (PDP), calendrier, sanctions, comment se préparer.',
    category: 'Gestion',
    tags: ['Facturation électronique', 'PDP', 'Chorus Pro', 'Obligation', '2026'],
    readTime: 13,
    publishedAt: '2026-04-14',
    featured: true
  },
  {
    id: '49',
    title: 'Contrat freelance : les 10 clauses indispensables en 2026',
    slug: 'contrat-freelance-clauses-indispensables-2026',
    excerpt: 'Propriété intellectuelle, RGPD, pénalités, résiliation, non-concurrence : les clauses juridiques à ne jamais oublier dans vos contrats de mission.',
    category: 'Freelance pratique',
    tags: ['Contrat', 'Juridique', 'Freelance', 'Clauses', 'RGPD'],
    readTime: 12,
    publishedAt: '2026-04-13',
    featured: false
  },
  {
    id: '50',
    title: 'Fiscalité crypto pour freelance et entrepreneur en 2026',
    slug: 'fiscalite-crypto-freelance-2026',
    excerpt: 'Bitcoin, Ethereum, staking, DeFi : comment déclarer et optimiser vos gains crypto en tant que freelance ou dirigeant en 2026.',
    category: 'Fiscalité',
    tags: ['Crypto', 'Bitcoin', 'Fiscalité', 'DeFi', 'Déclaration'],
    readTime: 14,
    publishedAt: '2026-04-12',
    featured: true
  },
  {
    id: '51',
    title: 'Recruter son premier salarié en SASU/EURL : le guide complet 2026',
    slug: 'recruter-premier-salarie-sasu-eurl-2026',
    excerpt: 'Passer de freelance seul à employeur : coût réel d\'un salarié, aides à l\'embauche, obligations, contrats, DPAE. Le playbook chiffré.',
    category: 'Gestion',
    tags: ['Recrutement', 'Salarié', 'SASU', 'EURL', 'Employeur'],
    readTime: 15,
    publishedAt: '2026-04-11',
    featured: false
  },
  {
    id: '52',
    title: 'Freelance et impayés : recouvrement amiable et judiciaire en 2026',
    slug: 'freelance-impayes-recouvrement-2026',
    excerpt: 'Client qui ne paie pas ? Relances, mise en demeure, injonction de payer, procédure européenne : toutes les armes du freelance en 2026.',
    category: 'Gestion',
    tags: ['Impayés', 'Recouvrement', 'Freelance', 'Juridique', 'Facture'],
    readTime: 12,
    publishedAt: '2026-04-10',
    featured: false
  },
  {
    id: '53',
    title: 'Céder sa clientèle freelance : évaluer et vendre son activité en 2026',
    slug: 'ceder-clientele-freelance-2026',
    excerpt: 'Vendre son portefeuille clients, son site, sa société : méthodes d\'évaluation, fiscalité de la plus-value, garantie de passif. Le guide de la sortie freelance.',
    category: 'Optimisation',
    tags: ['Cession', 'Vente', 'Clientèle', 'Plus-value', 'Exit'],
    readTime: 14,
    publishedAt: '2026-04-09',
    featured: true
  },
  {
    id: '54',
    title: 'Freelance expatrié : Portugal, Dubaï, Estonie — fiscalité 2026',
    slug: 'freelance-expatrie-portugal-dubai-estonie-2026',
    excerpt: 'S\'expatrier pour optimiser sa fiscalité : NHR Portugal, résidence Dubaï, e-Residency Estonie. Conditions, pièges, exit tax français en 2026.',
    category: 'Optimisation',
    tags: ['Expatriation', 'Portugal', 'Dubaï', 'Estonie', 'Fiscalité internationale'],
    readTime: 15,
    publishedAt: '2026-04-08',
    featured: false
  },
  {
    id: '55',
    title: 'Conjoint collaborateur : le statut pour couples entrepreneurs en 2026',
    slug: 'conjoint-collaborateur-couple-entrepreneur-2026',
    excerpt: 'Votre conjoint(e) participe à votre activité freelance ? Découvrez les 3 statuts (collaborateur, salarié, associé), leurs coûts et leur protection sociale.',
    category: 'Protection sociale',
    tags: ['Conjoint', 'Couple', 'Statut', 'Protection sociale', 'Famille'],
    readTime: 11,
    publishedAt: '2026-04-07',
    featured: false
  },
  {
    id: '56',
    title: 'Formation professionnelle freelance : CPF, FIF-PL et OPCO en 2026',
    slug: 'formation-professionnelle-freelance-cpf-fifpl-2026',
    excerpt: 'Utilisez votre budget formation : CPF, FIF-PL pour libéraux, AGEFICE pour commerçants, OPCO pour dirigeants. Comment financer 100% de votre montée en compétence.',
    category: 'Bons plans/Conseils',
    tags: ['Formation', 'CPF', 'FIF-PL', 'OPCO', 'AGEFICE'],
    readTime: 11,
    publishedAt: '2026-04-06',
    featured: false
  },
  {
    id: '57',
    title: 'Freelance et IA : fiscalité, RC pro et droits d\'auteur en 2026',
    slug: 'freelance-ia-fiscalite-rc-droits-auteur-2026',
    excerpt: 'ChatGPT, Midjourney, Claude : utiliser l\'IA en freelance en 2026. Statut fiscal des livrables IA, responsabilité, propriété intellectuelle, AI Act européen.',
    category: 'Bons plans/Conseils',
    tags: ['IA', 'ChatGPT', 'AI Act', 'Droits d\'auteur', 'RC Pro'],
    readTime: 13,
    publishedAt: '2026-04-05',
    featured: true
  },
  {
    id: '58',
    title: 'Acheter un bien immobilier : SASU/EURL directe vs SCI vs holding+SCI en 2026',
    slug: 'immobilier-sasu-eurl-vs-sci-vs-holding-sci-2026',
    excerpt: 'Le comparatif chiffré des 3 stratégies pour acheter un bien immobilier en tant que freelance : achat direct par la société, SCI patrimoniale, ou holding + SCI. Fiscalité, financement, transmission.',
    category: 'Optimisation',
    tags: ['Immobilier', 'SCI', 'Holding', 'SASU', 'EURL', 'Comparatif'],
    readTime: 16,
    publishedAt: '2026-04-24',
    featured: true
  },
  {
    id: '59',
    title: 'SCI à l\'IR vs SCI à l\'IS pour freelance : le match 2026',
    slug: 'sci-ir-vs-sci-is-freelance-2026',
    excerpt: 'Louer, revendre, transmettre : quel régime fiscal choisir pour votre SCI en tant que freelance ? Le comparatif complet des impacts en 2026.',
    category: 'Optimisation',
    tags: ['SCI', 'IR', 'IS', 'Immobilier', 'Fiscalité'],
    readTime: 13,
    publishedAt: '2026-04-23',
    featured: false
  },
  {
    id: '60',
    title: 'LMNP/LMP en tant que freelance : cumul optimal en 2026',
    slug: 'lmnp-lmp-freelance-cumul-2026',
    excerpt: 'Cumuler votre activité freelance avec un statut de loueur meublé (LMNP ou LMP) : plafonds, amortissements, exonérations, calculs 2026.',
    category: 'Optimisation',
    tags: ['LMNP', 'LMP', 'Immobilier', 'Location meublée', 'Cumul'],
    readTime: 13,
    publishedAt: '2026-04-22',
    featured: false
  },
  {
    id: '61',
    title: 'Démembrement de propriété pour dirigeant : usufruit et nue-propriété en 2026',
    slug: 'demembrement-propriete-dirigeant-2026',
    excerpt: 'Séparer usufruit et nue-propriété pour transmettre en optimisant : mécanismes, barème fiscal 2026, cas concrets pour freelance et dirigeant.',
    category: 'Optimisation',
    tags: ['Démembrement', 'Usufruit', 'Nue-propriété', 'Transmission', 'Immobilier'],
    readTime: 12,
    publishedAt: '2026-04-21',
    featured: false
  },
  {
    id: '62',
    title: 'Créer une SCI en couple : régime matrimonial et transmission en 2026',
    slug: 'sci-couple-regime-matrimonial-2026',
    excerpt: 'Marié, pacsé ou concubin : comment structurer sa SCI en couple pour protéger le patrimoine, optimiser la fiscalité et anticiper la transmission.',
    category: 'Optimisation',
    tags: ['SCI', 'Couple', 'Régime matrimonial', 'Transmission', 'Immobilier'],
    readTime: 11,
    publishedAt: '2026-04-20',
    featured: false
  },
  {
    id: '63',
    title: 'Investir en SCPI via société freelance : le guide 2026',
    slug: 'scpi-via-societe-freelance-2026',
    excerpt: 'Acheter des SCPI avec sa SASU, EURL ou holding : fiscalité IS, taux de rendement, comparatif détention personnelle vs société en 2026.',
    category: 'Optimisation',
    tags: ['SCPI', 'Immobilier papier', 'Société', 'Holding', 'IS'],
    readTime: 12,
    publishedAt: '2026-04-19',
    featured: false
  },
  {
    id: '64',
    title: 'CIR, CII et JEI : les crédits d\'impôt méconnus pour freelance en 2026',
    slug: 'cir-cii-jei-credits-impot-freelance-2026',
    excerpt: 'Crédit d\'Impôt Recherche, Crédit d\'Impôt Innovation, statut Jeune Entreprise Innovante : réduire son IS de 30% à 60%. Éligibilité, dossier, montants en 2026.',
    category: 'Optimisation',
    tags: ['CIR', 'CII', 'JEI', 'Crédit impôt', 'Innovation'],
    readTime: 13,
    publishedAt: '2026-04-18',
    featured: true
  },
  {
    id: '65',
    title: 'Passer de micro-entreprise à SASU/EURL : la transformation en 2026',
    slug: 'micro-vers-sasu-eurl-transformation-2026',
    excerpt: 'Quand quitter la micro pour SASU ou EURL ? Procédure de transformation (fermeture + création), coûts, calendrier, cas concret chiffré.',
    category: 'Optimisation',
    tags: ['Micro-entreprise', 'SASU', 'EURL', 'Transformation', 'Statut'],
    readTime: 12,
    publishedAt: '2026-04-17',
    featured: false
  },
  {
    id: '66',
    title: 'Régime réel BNC vs abattement 34% micro-BNC : quand basculer en 2026',
    slug: 'regime-reel-bnc-vs-abattement-34-2026',
    excerpt: 'Micro-BNC avec abattement 34% ou régime réel avec frais déductibles ? Le calcul exact du seuil de bascule en 2026 pour freelance libéral.',
    category: 'Optimisation',
    tags: ['BNC', 'Micro', 'Régime réel', 'Abattement', 'Libéral'],
    readTime: 11,
    publishedAt: '2026-04-16',
    featured: false
  },
  {
    id: '67',
    title: 'Louer son local à sa société via SCI : le self-rental freelance 2026',
    slug: 'self-rental-sci-societe-freelance-2026',
    excerpt: 'Créer une SCI qui achète votre bureau et le loue à votre SASU/EURL : loyer déductible, capitalisation immobilière, transmission. Le montage patrimonial expliqué.',
    category: 'Optimisation',
    tags: ['SCI', 'Self-rental', 'Bureau', 'Immobilier pro', 'Holding'],
    readTime: 13,
    publishedAt: '2026-04-15',
    featured: true
  }
];

// Catégories
export const categories = [
  { id: 'guides', name: 'Guides complets', count: 8 },
  { id: 'erreurs', name: 'Erreurs à éviter', count: 4 },
  { id: 'freelance', name: 'Freelance pratique', count: 10 },
  { id: 'fiscalite', name: 'Fiscalité/Statuts', count: 16 },
  { id: 'chomage', name: 'Chômage & aides', count: 7 },
  { id: 'gestion', name: 'Gestion', count: 6 },
  { id: 'protection', name: 'Protection sociale', count: 5 },
  { id: 'optimisation', name: 'Optimisation', count: 11 },
  { id: 'bons-plans', name: 'Bons plans/Conseils', count: 5 }
];

// Tags populaires
export const popularTags = [
  'SASU', 'Freelance', 'Micro-entreprise', 'EURL', 'Chômage', 'ARE', 'Fiscalité', 'TJM', 'Création', 'Optimisation'
];

// Mini-simulateurs
export const miniSimulators = [
  {
    id: 'revenu-freelance',
    title: 'Revenu net freelance',
    description: 'Calculez votre revenu net à partir de votre TJM',
    icon: '💰',
    category: 'Freelance',
    popular: true
  },
  {
    id: 'salaire-dirigeant-sasu',
    title: 'Salaire dirigeant SASU',
    description: 'Simulez votre salaire optimal en SASU',
    icon: '👔',
    category: 'SASU',
    popular: true
  },
  {
    id: 'cout-dirigeant',
    title: 'Coût total dirigeant',
    description: 'Du brut au coût société complet',
    icon: '📊',
    category: 'Dirigeant',
    popular: false
  },
  {
    id: 'micro-entreprise',
    title: 'Charges micro-entreprise',
    description: 'Charges sociales et fiscales en micro',
    icon: '🏪',
    category: 'Micro',
    popular: true
  },
  {
    id: 'is-vs-ir',
    title: 'IS vs IR',
    description: 'Comparaison fiscale simple et claire',
    icon: '⚖️',
    category: 'Fiscal',
    popular: false
  },
  {
    id: 'dividendes',
    title: 'Dividendes SASU/EURL',
    description: 'Optimisez vos dividendes',
    icon: '📈',
    category: 'Dividendes',
    popular: false
  },
  {
    id: 'urssaf',
    title: 'Charges URSSAF',
    description: 'Estimez vos cotisations URSSAF',
    icon: '🏛️',
    category: 'Charges',
    popular: false
  },
  {
    id: 'tva',
    title: 'TVA à payer/récupérer',
    description: 'Calculez votre TVA nette',
    icon: '🧾',
    category: 'TVA',
    popular: false
  },
  {
    id: 'are-creation',
    title: 'ARE + création',
    description: 'Vos droits ARE en créant',
    icon: '🤝',
    category: 'Chômage',
    popular: true
  },
  {
    id: 'acre',
    title: 'ACRE - Gain réel',
    description: 'Calculez le gain de l\'ACRE',
    icon: '🎯',
    category: 'Aides',
    popular: false
  },
  {
    id: 'are-vs-arce',
    title: 'Maintien ARE vs ARCE',
    description: 'Que choisir : ARE ou ARCE ?',
    icon: '🔄',
    category: 'Chômage',
    popular: false
  },
  {
    id: 'demission-chomage',
    title: 'Démission + chômage',
    description: 'Droits chômage après démission',
    icon: '🚪',
    category: 'Chômage',
    popular: false
  },
  {
    id: 'quel-statut',
    title: 'Quel statut choisir ?',
    description: 'Le statut le plus rentable',
    icon: '🏆',
    category: 'Statut',
    popular: true
  },
  {
    id: 'micro-vs-sasu-eurl',
    title: 'Micro vs SASU vs EURL',
    description: 'Comparatif complet des statuts',
    icon: '🤺',
    category: 'Comparatif',
    popular: true
  },
  {
    id: 'quitter-micro',
    title: 'Quand quitter la micro ?',
    description: 'Le bon moment pour changer',
    icon: '⏰',
    category: 'Micro',
    popular: false
  }
];

// Mock result pour simulateurs
export const getMockSimulatorResult = (simulatorId, inputs) => {
  const results = {
    'revenu-freelance': {
      title: 'Résultat simulation - Revenu net freelance',
      data: {
        tjm: inputs.tjm || 400,
        joursAnnuels: inputs.jours || 200,
        chiffreAffaires: (inputs.tjm || 400) * (inputs.jours || 200),
        chargesSociales: Math.round(((inputs.tjm || 400) * (inputs.jours || 200)) * 0.22),
        revenuNet: Math.round(((inputs.tjm || 400) * (inputs.jours || 200)) * 0.78)
      },
      disclaimer: 'Estimation basée sur les taux 2026. Résultat indicatif.'
    },
    'salaire-dirigeant-sasu': {
      title: 'Résultat simulation - Salaire dirigeant SASU',
      data: {
        salaireBrut: inputs.salaire || 3000,
        chargesPatronales: Math.round((inputs.salaire || 3000) * 0.42),
        chargesSalariales: Math.round((inputs.salaire || 3000) * 0.22),
        salaireNet: Math.round((inputs.salaire || 3000) * 0.78),
        coutTotal: Math.round((inputs.salaire || 3000) * 1.42)
      },
      disclaimer: 'Simulation 2026. Consultez un expert pour votre situation.'
    }
  };
  
  return results[simulatorId] || { title: 'Résultat', data: {}, disclaimer: 'Estimation 2026' };
};